import { globals } from '@/src/globals'

export const pricingHoverEffect = (pricingBlock: HTMLElement): void => {
  const pricingTable = pricingBlock.querySelector('.js-pricing-table') as unknown as HTMLElement

  const pricingSection_first = pricingTable.querySelectorAll('.js-pricing-table-first') as unknown as HTMLElement[]

  const pricingSection_second = pricingTable.querySelectorAll('.js-pricing-table-second') as unknown as HTMLElement[]

  pricingSection_first.forEach(single => {
    single.addEventListener('mouseenter', () => {
      pricingSection_first.forEach(singleSub => {
        singleSub.classList.add('-hasHover')
      })
    })

    single.addEventListener('mouseleave', () => {
      pricingSection_first.forEach(singleSub => {
        singleSub.classList.remove('-hasHover')
      })
    })
  })

  pricingSection_second.forEach(single => {
    single.addEventListener('mouseenter', () => {
      pricingSection_second.forEach(singleSub => {
        singleSub.classList.add('-hasHover')
      })
    })

    single.addEventListener('mouseleave', () => {
      pricingSection_second.forEach(singleSub => {
        singleSub.classList.remove('-hasHover')
      })
    })
  })
}
